// ** Icons Import
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();

  const isCheckoutRoute = /^\/checkout\/[a-fA-F0-9-]+$/.test(location.pathname);

  return (
    <p className="clearfix mb-0 mt-5">
      <span className="float-md-left d-block d-md-inline-block mt-25">
        COPYRIGHT © {new Date().getFullYear()}{' '}
        <span className="d-none d-sm-inline-block">
          , Todos os direitos reservados
          {isCheckoutRoute
            ? ' - Pagamento processado por UltraPayments LTDA'
            : ''}
        </span>
      </span>
    </p>
  );
};

export default Footer;
